import { composeValidators } from '@alfa-bank/site-form-helpers/validation/utils';

import { getMaxLengthValidator } from '.';

export const ADDRESS_MESSAGE = 'Необходимо выбрать адрес из предложенного списка';

// логика валидации поля с адресом
export const isValidAddress = (value?: string) => {
    if (!value) {
        return ADDRESS_MESSAGE;
    }

    return undefined;
};

export const validateAddress = () => composeValidators(getMaxLengthValidator(200), isValidAddress);
